import Modal from 'trunks/vue/admin/components/modals/modal.js';
import WebhookModalContent from './webhook_modal_content.js';

export default Vue.extend({
  components: {
    modal: Modal,
    'webhook-modal-content': WebhookModalContent,
  },

  template: `
    <modal title="修改Webhook" ref="modal">
      <webhook-modal-content
        :webhook="webhook"
        :all-events="allEvents"
        class="modal-body"
        @valueChanged="valueChangedFunc"
      />
      <div slot='footer' class="modal-footer">
        <button class="outlined btn-default" @click='cancel'>取消</button>
        <button @click='save'>确定</button>
      </div>
    </modal>
  `,

  props: {
    webhook: {
      type: Object,
      required: true,
    },
    webhookableId: {
      type: Number,
      required: true,
    },
    allEvents: {
      type: Array,
      required: true,
    },
    webhookablePath: {
      type: String,
      required: true,
    },
  },

  methods: {
    valueChangedFunc(webhook) {
      this.webhook = webhook;
    },

    cancel() {
      this.$refs.modal.close();
    },

    save() {
      Skylark.Libs.Ajax.put(`/admin/${this.webhookablePath}/${this.webhookableId}/webhooks/${this.webhook.id}`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: this.webhook,
        success: () => {
          this.$refs.modal.close();
          Skylark.Bridge.newAlertify('编辑成功', {
            type: 'success',
          });
          this.$emit('editSuccessed', this.webhook);
        },
        error: () => {
          Skylark.Bridge.newAlertify('操作失败，请重试', {
            type: 'error',
          });
        },
      });
    },
  },
});
